// extracted by mini-css-extract-plugin
module.exports = {"container":"style_container__mfS1U","mb_16px":"style_mb_16px__Op_Qm","coupons_index_link":"style_coupons_index_link__sBqHd","heading":"style_heading__ByduG"};